import React from "react";
import { Modal, Button } from "react-bootstrap";

interface ConfirmModalProps {
  show: boolean;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  title = "Confirm action",
  message,
  onConfirm,
  onCancel,
}) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton className="bg-light">
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{message}</p>
    </Modal.Body>
    <Modal.Footer className="justify-content-end">
      <Button
        variant="warning"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        variant="success"
        onClick={onConfirm}
      >
        Confirm
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal;